import { React } from 'react';
import ServiceSection from '../../../../ServiceSection/ServiceSection';
import SatelliteText from '../../../SatelliteText/SatelliteText';
import satelliteIcon from '../../../satelliteIcon';

const SignsItSupport4 = props => (
    <ServiceSection noPadTitle singleTitle icon={satelliteIcon} {...props} page="signsItSupport" section="nextSteps">
        <div className='TextGroup Satellite'>
            <div className='container-custom subtitle'>
                <SatelliteText t={props.t} prefix="signsItSupport:nextSteps" first noPadBottom />
            </div>
        </div>
    </ServiceSection>
);

export default SignsItSupport4;
